module.exports = __webpack_public_path__ + "media/public/img/market_pulse/market_pulse-2-956b3f9e7158ddcc93da039bca4c4a95.svg";